module.exports = __webpack_public_path__ + "img/apprentice.4fe788e1.png";